import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { jobTitleSchema } from "./schema";
import { fetchjobTitleData } from "./read";
import { useUpdateJobTitle } from "../update/mutation";
import { useCreateJobTitle } from "../create/mutation";

export const useJobTitleForm = ({ jobtitleId }) => {
  const form = useForm({
    resolver: zodResolver(jobTitleSchema),
    defaultValues: {
      name: "",
    },
  });

  const updateJobTitle = useUpdateJobTitle();
  const createJobTitle = useCreateJobTitle();

  const handleCreate = async (context) => {
    const item = context.values;
    await createJobTitle.mutateAsync({ item });
  };

  const handleUpdate = async (id, context) => {
    const values = context.dirtyValues;
    await updateJobTitle.mutateAsync({ jobtitleId: id, item: values });
  };

  const handleRead = async (id) => {
    const response = await fetchjobTitleData({ jobtitleId: id });
    return response;
  };

  return {
    form,
    handleCreate,
    handleUpdate,
    handleRead,
  };
};
